document.querySelectorAll(".bundle-builder").forEach(initBundleBuilder);

function initBundleBuilder(builder) {
  const purchaseTypes = Array.from(
    builder.querySelectorAll(".purchase-type > [data-type]"),
  );
  const remainingSlotEls = Array.from(
    builder.querySelectorAll("[data-remaining-slot]"),
  );
  const checkoutBtn = builder.querySelector("[data-checkout]");
  const priceWrap = builder.querySelector(".btn--price");
  const priceSpan = priceWrap?.querySelector("span");
  const compareEl = priceWrap?.querySelector("s");
  const variantOptions = Array.from(
    builder.querySelectorAll(".el-variant__option"),
  );
  const singleVariantMode = variantOptions.length === 1;
  const GIFT_VARIANT_ID = 51852758909230;

  let selectedVariants = {}; // { variantId: qty }

  purchaseTypes.forEach((typeEl) => {
    typeEl.addEventListener("click", (e) => {
      if (e.target.closest(".bundle-selector")) return;
      setActivePurchaseType(typeEl);
    });

    const bundles = Array.from(typeEl.querySelectorAll(".bundle--item"));
    bundles.forEach((bundle) => {
      bundle.addEventListener("click", (e) => {
        e.stopPropagation();
        setActivePurchaseType(typeEl);
        setActiveBundle(typeEl, bundle);
      });
    });
  });

  variantOptions.forEach((option) => {
    const addBtn = option.querySelector(".variant-add");
    if (!addBtn) return;

    addBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const variantId = option.dataset.id;
      const currentQty = getSelectedQty(variantId);
      const remaining = getRemainingSlots();

      if (currentQty > 0) return;

      if (remaining <= 0) return;

      setVariantQty(variantId, 1);
    });
  });

  function updateGiftRewards() {
    const activeType = getActivePurchaseType();
    const activeBundle = getActiveBundle();
    const rewardItems = Array.from(builder.querySelectorAll(".gift--item"));

    if (!activeType || !activeBundle || !rewardItems.length) return;

    const isSubscription = activeType.dataset.type === "subscription";
    const selectedQty = Number(activeBundle.dataset.qty || 0);

    rewardItems.forEach((item) => {
      const threshold = Number(item.dataset.threshold || 0);
      const unlockedText = item.dataset.unlockedText || "";
      const lockedImg = item.dataset.imgLocked || "";
      const unlockedImg = item.dataset.imgUnlocked || "";
      const img = item.querySelector("img");
      const text = item.querySelector("p");

      const isUnlocked = isSubscription && selectedQty >= threshold;

      if (img) {
        img.src = isUnlocked ? unlockedImg : lockedImg;
        img.alt = isUnlocked ? "Unlocked reward" : "Locked reward";
      }

      if (text) {
        text.innerHTML = isUnlocked
          ? unlockedText
          : `${threshold}+ Packs<br>To Unlock`;
      }

      item.classList.toggle("is-unlocked", isUnlocked);
      item.classList.toggle("is-locked", !isUnlocked);
    });
  }

  function setActivePurchaseType(typeEl) {
    purchaseTypes.forEach((el) => el.classList.remove("active"));
    typeEl.classList.add("active");

    const activeBundle = getActiveBundle();
    const requiredQty = getRequiredQty();

    if (singleVariantMode && variantOptions[0]) {
      selectedVariants = {};
      selectedVariants[variantOptions[0].dataset.id] = requiredQty;
    } else {
      normalizeSelectionsToBundle();
    }

    updateUI();
  }

  function setActiveBundle(typeEl, bundleEl) {
    const bundles = Array.from(typeEl.querySelectorAll(".bundle--item"));
    bundles.forEach((el) => el.classList.remove("active"));
    bundleEl.classList.add("active");

    const requiredQty = getRequiredQty();

    if (singleVariantMode && variantOptions[0]) {
      selectedVariants = {};
      selectedVariants[variantOptions[0].dataset.id] = requiredQty;
    } else {
      normalizeSelectionsToBundle();
    }

    updateUI();
  }

  function getActivePurchaseType() {
    return (
      builder.querySelector(".purchase-type > [data-type].active") ||
      purchaseTypes[0]
    );
  }

  function getActiveBundle() {
    const activeType = getActivePurchaseType();
    return (
      activeType?.querySelector(".bundle--item.active") ||
      activeType?.querySelector(".bundle--item")
    );
  }

  function getPurchaseMode() {
    return getActivePurchaseType()?.dataset.type || "subscription";
  }

  function getRequiredQty() {
    const activeBundle = getActiveBundle();
    return Number(activeBundle?.dataset.qty || 1);
  }

  function getSelectedTotal() {
    return Object.values(selectedVariants).reduce((sum, qty) => sum + qty, 0);
  }

  function getRemainingSlots() {
    return Math.max(getRequiredQty() - getSelectedTotal(), 0);
  }

  function getSelectedQty(variantId) {
    return Number(selectedVariants[variantId] || 0);
  }

  function setVariantQty(variantId, qty) {
    const safeQty = Math.max(0, Number(qty) || 0);

    if (safeQty === 0) {
      delete selectedVariants[variantId];
    } else {
      selectedVariants[variantId] = safeQty;
    }

    normalizeSelectionsToBundle();
    updateUI();
  }

  function normalizeSelectionsToBundle() {
    const requiredQty = getRequiredQty();
    let total = getSelectedTotal();

    if (total <= requiredQty) return;

    const ids = Object.keys(selectedVariants);

    while (total > requiredQty && ids.length) {
      const lastId = ids[ids.length - 1];
      if (selectedVariants[lastId] > 0) {
        selectedVariants[lastId] -= 1;
        total -= 1;

        if (selectedVariants[lastId] <= 0) {
          delete selectedVariants[lastId];
          ids.pop();
        }
      } else {
        ids.pop();
      }
    }
  }

  function renderVariantControls() {
    const requiredQty = getRequiredQty();
    const totalSelected = getSelectedTotal();

    variantOptions.forEach((option) => {
      const variantId = option.dataset.id;
      const currentQty = getSelectedQty(variantId);
      const addBtn = option.querySelector(".variant-add");
      if (!addBtn) return;

      if (currentQty <= 0) {
        addBtn.classList.remove("is-qty");
        addBtn.innerHTML = "ADD";
        addBtn.disabled = totalSelected >= requiredQty;
        return;
      }

      addBtn.classList.add("is-qty");
      addBtn.disabled = false;
      addBtn.innerHTML = `
          <span class="qty-minus" type="button">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="30" height="30" rx="15" fill="#001B3C"/>
          <path d="M11 13.5H19V16.5H11V13.5Z" fill="white"/>
          </svg>
          </span>
          <span class="qty-value">${currentQty}</span>
          <span class="qty-plus" type="button">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="30" height="30" rx="15" fill="#001B3C"/>
          <path d="M13.9881 10H16.0119V13.9921H20V16.0079H16.0119V20H13.9881V16.0079H10V13.9921H13.9881V10Z" fill="white"/>
          </svg>
          </span>
        `;

      const minus = addBtn.querySelector(".qty-minus");
      const plus = addBtn.querySelector(".qty-plus");

      minus.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        setVariantQty(variantId, currentQty - 1);
      });

      plus.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const remaining = getRemainingSlots();
        if (remaining <= 0) return;

        setVariantQty(variantId, currentQty + 1);
      });
    });
  }

  function updateRemainingSlotText() {
    const remaining = getRemainingSlots();
    const heading = builder.querySelector("[data-variant-header] h5");

    remainingSlotEls.forEach((el) => {
      el.textContent = remaining;
    });

    if (heading) {
      if (remaining === 0) {
        heading.textContent = "Selection Complete";
        heading.classList.add("selection--complete");
      } else {
        heading.innerHTML = `Select Your <span class="remaining-slot" data-remaining-slot>${remaining}</span> More Flavors`;
        heading.classList.remove("selection--complete");
      }
    }
  }

  function updateButtonPrice() {
    const activeBundle = getActiveBundle();
    const mode = getPurchaseMode();

    if (!activeBundle || !priceSpan || !compareEl) return;

    const price =
      mode === "subscription"
        ? activeBundle.dataset.priceSubscription
        : activeBundle.dataset.priceOnetime;

    const compare =
      mode === "subscription"
        ? activeBundle.dataset.priceOnetime
        : activeBundle.dataset.compareOnetime;

    priceSpan.textContent = price || "";

    if (compare) {
      compareEl.textContent = compare;
      compareEl.style.display = "";
    } else {
      compareEl.textContent = "";
      compareEl.style.display = "none";
    }
  }

  function updateCheckoutState() {
    const remaining = getRemainingSlots();
    const isReady = remaining === 0;

    if (!checkoutBtn) return;

    checkoutBtn.disabled = !isReady;
    checkoutBtn.classList.toggle("is-disabled", !isReady);
  }

  async function handleCheckout(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();
    }

    if (!checkoutBtn || checkoutBtn.disabled) return;

    const mode = getPurchaseMode();
    const activeType = getActivePurchaseType();
    const activeBundle = getActiveBundle();
    const sellingPlanId = activeType?.dataset.sellingId;
    const requiredQty = getRequiredQty();
    const qualifiesForGift =
      mode === "subscription" && Number(activeBundle?.dataset.qty || 0) === 6;

    let items = Object.entries(selectedVariants).map(([id, quantity]) => {
      const item = {
        id: Number(id),
        quantity: Number(quantity),
      };

      if (mode === "subscription" && sellingPlanId) {
        item.selling_plan = Number(sellingPlanId);
      }

      return item;
    });

    if (!items.length && singleVariantMode && variantOptions[0]) {
      const fallbackId = Number(variantOptions[0].dataset.id);
      const fallbackQty = requiredQty;

      const item = {
        id: fallbackId,
        quantity: fallbackQty,
      };

      if (mode === "subscription" && sellingPlanId) {
        item.selling_plan = Number(sellingPlanId);
      }

      items = [item];
    }

    if (!items.length) return;

    if (qualifiesForGift) {
      items.push({
        id: 51852758909230,
        quantity: 1,
      });
    }

    try {
      checkoutBtn.disabled = true;
      checkoutBtn.classList.add("is-loading");

      const expectedComparePrice =
        mode === "subscription"
          ? activeBundle?.dataset.compareSubscription
          : activeBundle?.dataset.compareOnetime;

      const form = document.createElement("form");
      form.method = "POST";
      form.action = "/cart/add";
      form.style.display = "none";

      const returnInput = document.createElement("input");
      returnInput.type = "hidden";
      returnInput.name = "return_to";
      returnInput.value = "/checkout";
      form.appendChild(returnInput);

      items.forEach((item, index) => {
        const idInput = document.createElement("input");
        idInput.type = "hidden";
        idInput.name = `items[${index}][id]`;
        idInput.value = item.id;
        form.appendChild(idInput);

        const qtyInput = document.createElement("input");
        qtyInput.type = "hidden";
        qtyInput.name = `items[${index}][quantity]`;
        qtyInput.value = item.quantity;
        form.appendChild(qtyInput);

        if (item.id !== 51852758909230 && expectedComparePrice) {
          const propInput = document.createElement("input");
          propInput.type = "hidden";
          propInput.name = `items[${index}][properties][Original Price]`;
          propInput.value = expectedComparePrice;
          form.appendChild(propInput);
        }

        if (
          mode === "subscription" &&
          sellingPlanId &&
          item.id !== 51852758909230
        ) {
          const planInput = document.createElement("input");
          planInput.type = "hidden";
          planInput.name = `items[${index}][selling_plan]`;
          planInput.value = sellingPlanId;
          form.appendChild(planInput);
        }
      });

      await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
      });

      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.error("Checkout failed:", error);
      checkoutBtn.disabled = false;
      checkoutBtn.classList.remove("is-loading");
    }
  }

  function updateUI() {
    updateRemainingSlotText();
    updateButtonPrice();
    renderVariantControls();
    updateCheckoutState();
    updateGiftRewards();
  }

  if (checkoutBtn) {
    checkoutBtn.setAttribute("type", "button");

    checkoutBtn.addEventListener("click", (e) => {
      handleCheckout(e);
    });
  }

  const initialType = getActivePurchaseType();
  if (initialType) {
    const initialBundle = getActiveBundle();
    if (initialBundle) {
      setActiveBundle(initialType, initialBundle);
    } else {
      updateUI();
    }
  } else {
    updateUI();
  }
}
